// Public test-fixture identity set re-exported through the `/fixtures`
// entrypoint. Consumers: spectrum-docs/integration-tests and spectrum-sdk
// integration tests. Values here must stay stable — changing a reference
// address rewrites captured fixtures.
//
// Internal-only fixture inputs (whales, collectors, reference calldata)
// live in ./testing/fixture-inputs.ts and are not re-exported publicly.
import { CORE_REGRESSION_CHAINS, EVM_CHAIN_SLUGS, REGRESSION_BLOCK_HEIGHTS, SUPPORTED_CHAIN_SLUGS, } from './chains.js';
import { CHAIN_USDC_ADDRESSES } from './tokens.js';
export { CORE_REGRESSION_CHAINS, EVM_CHAIN_SLUGS, REGRESSION_BLOCK_HEIGHTS, SUPPORTED_CHAIN_SLUGS };
// ─── Reference EVM addresses ──────────────────────────────────────────
export const VITALIK = '0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045';
export const DEAD_ADDRESS = '0x000000000000000000000000000000000000dEaD';
export const BAYC = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D';
export const OPENSEA_1155 = '0x495f947276749Ce646f68AC8c248420045cb7b5e';
// ─── Reference Solana addresses / mints ───────────────────────────────
export const SOL_USDC_MINT = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
export const SOL_SOL_MINT = 'So11111111111111111111111111111111111111112';
export const SOL_WALLET = '9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM';
// PayPal USD — a Token-2022 mint (uses the inline metadata extension, not Metaplex).
export const SOL_PYUSD_MINT = '2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo';
// ─── Reference Starknet addresses ─────────────────────────────────────
export const STARKNET_ETH_TOKEN = '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7';
export const STARKNET_STRK_TOKEN = '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d';
export const STARKNET_WALLET = '0x01176a1bd84444c89232ec27754698e5d2e7e1a7f1539f12027f28b23ec9f3d8';
export const STARKNET_ERC20_BALANCE_OF_SELECTOR = '0x2e4263afad30923c891518314c3c95dbe830a16874e8abc5777a9a20b54c76e';
export const STARKNET_ERC20_DECIMALS_SELECTOR = '0x4c4fb1ab068f6039d5780c68dd0fa2f8742cceb3426d19667778ca7f3518a9';
// ─── Common topic / identifier constants ──────────────────────────────
export const TRANSFER_TOPIC = '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';
// ─── Canonical token/pool identifiers consumed by integration tests ───
/** Canonical USDC contract per EVM chain. Re-exported as `USDC_BY_CHAIN` so
 *  integration tests can import a single stable name from `/fixtures`. */
export const USDC_BY_CHAIN = CHAIN_USDC_ADDRESSES;
/** Symbolic Aave pool key (USDC) used by yield balance/price/lending tests. */
export const AAVE_POOL = 'USDC';
/** Pendle V2 market address on ethereum used by Pendle implied-APY tests. */
export const PENDLE_MARKET = '0x7d372819240d14fb477f17b964f95f33beb4c704';
/** Avantis vault symbol used by the avantis price fixture. */
export const AVANTIS_VAULT = 'avUSDC';
